module.exports = __webpack_public_path__ + "img/天力冲锋衣2.e192a81f.jpg";